export default __webpack_public_path__ + "static/tutorials-jupyter-0f99f2cb30bfab63bfac296a745a1d37.png";